import { useState, useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import { AVAILABLE_ROUTES } from "constants/index";
import { useWindowSize } from "hooks";
import styled from "styled-components";
import BottomNavigationMaterial from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";

import HomeIcon from "@material-ui/icons/Home";
import PhoneIcon from "@material-ui/icons/Phone";
import NotificationsIcon from "@material-ui/icons/Notifications";
import SettingsIcon from "@material-ui/icons/Settings";
import ShareIcon from "@material-ui/icons/Share";

const StyledBottomNavigationMaterial = styled(BottomNavigationMaterial)`
  .MuiBottomNavigationAction-root {
    min-width: ${({ minwidth }) => minwidth};
  }
`;

export const BottomNavigation = withRouter(() => {
  const [showNavigation, setShowNavigation] = useState(false);
  const [value, setValue] = useState("home");
  const gContext = useGlobalContext();
  const history = useHistory();
  const { width } = useWindowSize();

  const handleChange = (_, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case "home":
        history.push("/");
        break;
      case "numbers":
        history.push("/contactos");
        break;
      case "notifications":
        history.push("/notificaciones");
        break;
      case "config":
        history.push("/ajustes");
        break;
      default:
        gContext.toggleOpenShared();
        setValue("home");
        break;
    }
  };

  useEffect(() => {
    const getInitialItemSelect = () => {
      let item;
      switch (history.location.pathname) {
        case "/contactos":
          item = "numbers";
          break;
        case "/notificaciones":
          item = "notifications";
          break;
        case "/ajustes":
          item = "config";
          break;
        default:
          item = "home";
          break;
      }
      setValue(item);
    };

    getInitialItemSelect();
  }, []);

  useEffect(() => {
    const availablesRoutes = AVAILABLE_ROUTES.filter(
      (route) => route.indexOf(history.location.pathname) === -1,
      [AVAILABLE_ROUTES]
    );
    setShowNavigation(availablesRoutes.length !== AVAILABLE_ROUTES.length);
  }, [history.location.pathname]);

  const isMobile = width <= 425;

  if (!showNavigation) return null;

  return (
    <StyledBottomNavigationMaterial
      value={value}
      onChange={handleChange}
      minwidth={isMobile ? "60px" : "80px"}
    >
      <BottomNavigationAction
        label={isMobile ? "" : "Inicio"}
        value="home"
        icon={<HomeIcon />}
      />
      <BottomNavigationAction
        label={isMobile ? "" : "Números Emergencia"}
        value="numbers"
        icon={<PhoneIcon />}
      />
      <BottomNavigationAction
        label={isMobile ? "" : "Notificaciones"}
        value="notifications"
        icon={<NotificationsIcon />}
      />
      <BottomNavigationAction
        label={isMobile ? "" : "Configuración"}
        value="config"
        icon={<SettingsIcon />}
      />
      <BottomNavigationAction
        label={isMobile ? "" : "Compartir"}
        value="shared"
        icon={<ShareIcon />}
      />
    </StyledBottomNavigationMaterial>
  );
});
